import React from 'react';
import Styles from './index.less';
import classNames from 'classnames';

interface Props {
    style?: React.CSSProperties;
    isDragHover: boolean;
    canEdit: boolean;
    onDragPositionChange?: () => void;
    onClearDragPosition?: () => void;
}

interface State {
    isDragHover: boolean;
}

/**
 * 动画编辑组件，可展开或者折叠内容块
 */
export default class InsertIndicator extends React.Component<Props, State> {
    public constructor(props: Props, context: any) {
        super(props, context);

        this.state = {
            isDragHover: props.isDragHover,
        };
    }

    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(nextProps: Props) {
        if (this.state.isDragHover !== nextProps.isDragHover) {
            this.setState({ isDragHover: nextProps.isDragHover });
        }
    }

    private handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        if (!this.props.canEdit) return;
        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.dropEffect = 'move';

        if (!this.state.isDragHover) {
            this.setState({
                isDragHover: true,
            }, () => {
                this.props.onDragPositionChange?.();
            });
        }
    };
    private handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        if (!this.props.canEdit) return;
        e.preventDefault();
        e.stopPropagation();

        if (this.state.isDragHover) {
            this.setState({
                isDragHover: false,
            }, () => {
                this.props.onClearDragPosition?.();
            });
        }
    };

    private handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        if (!this.props.canEdit) return;
        e.preventDefault();
        e.stopPropagation();
        // 在hover状态下松手，需要将hover态重置
        if (this.state.isDragHover) {
            this.setState({
                isDragHover: false,
            });
        }
    };

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public render() {
        const indicatorStyle = { ...this.props.style, padding: '1px 0' };
        const hightlightClass = Styles.hightlightNew;
        return (
            <div
                style={indicatorStyle}
                className={Styles.indicatorContainer}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop}
            >
                <div className={classNames({
                    [Styles.indicator]: true,
                    [hightlightClass]: this.state.isDragHover,
                })}></div>
                <div className={classNames({
                    [Styles.indicatorLine]: true,
                    [hightlightClass]: this.state.isDragHover,
                })}></div>
            </div>
        );
    }
}
